import React from 'react'
import { Box, Card, CardContent, Container, Stack, Typography } from '@mui/material'
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded'

interface WipPageProps {
  title: string
}

const WipPage: React.FC<WipPageProps> = ({ title }) => {
  return (
    <Container maxWidth="xl" sx={{ py: { xs: 3, md: 5 } }}>
      <Card>
        <CardContent sx={{ p: { xs: 3, md: 4 } }}>
          <Stack spacing={1.5} sx={{ alignItems: 'center', textAlign: 'center' }}>
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: 3,
                display: 'grid',
                placeItems: 'center',
                border: '1px solid rgba(255,255,255,0.10)',
                background:
                  'linear-gradient(135deg, rgba(0,230,118,0.22), rgba(0,217,255,0.18), rgba(255,109,0,0.16))'
              }}
            >
              <ConstructionRoundedIcon sx={{ fontSize: 34 }} />
            </Box>
            <Typography variant="h4" sx={{ fontWeight: 900 }}>
              {title}
            </Typography>
            <Typography sx={{ color: 'text.secondary', maxWidth: 520 }}>
              Em desenvolvimento.
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Container>
  )
}

export default WipPage
